import { createIntl, createIntlCache } from 'react-intl'
import { AppStore } from 'state/store'
import da from '../../I18N/translations/da.json'
import de from '../../I18N/translations/de.json'
import en from '../../I18N/translations/en.json'
import es from '../../I18N/translations/es.json'
import fi from '../../I18N/translations/fi.json'
import it from '../../I18N/translations/it.json'

const translations: any = {
  de,
  en,
  da,
  fi,
  it,
  es,
}

const cache = createIntlCache()

//
// see https://github.com/formatjs/react-intl/blob/master/docs/API.md#createintl
//
export const intl = (store: AppStore) => () => {
  const locale = store.state.i18n.locale
  const language = locale.split(/[-_]/)[0] // language without region code
  const messages: any = translations[language] || translations['de']
  const intl = createIntl({ locale, messages }, cache)
  return intl
}
